import { SHOW_LOADER, HIDE_LOADER } from '../../common/actionConstants';

const requestArr = [];

export default function (state = false, action) {
    switch (action.type) {
        case SHOW_LOADER:
            requestArr.push(1);
            return true;

        case HIDE_LOADER:
            requestArr.pop();
            return requestArr.length ? true : false;

        default:
            return state;
    }
}